import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { IVentricularAssistDeviceState } from '../store/ventricularAssistDevice.types'
import { getVentricularAssistDeviceSelector } from '../selectors'
import { VentricularAssistDeviceConstants } from '../store/ventricularAssistDevice.constants'
import { throwPcrException } from '../../../pcr/store/pcr.actions'

export function* setVentricularAssistDeviceSiteAssessment() {
  try {
    const procedureState: IProcedureState = yield select(getProcedureStateSelector)
    const ventricularAssistDeviceState: IVentricularAssistDeviceState = yield select(getVentricularAssistDeviceSelector)
    const { inputRows } = procedureState
    const { siteAssessment } = ventricularAssistDeviceState
    inputRows.forEach((row) =>
      row.inputs.forEach((input) => {
        if (input.key === VentricularAssistDeviceConstants.SET_SITE_ASSESSMENT) {
          //@ts-ignore
          input.props.savedValues = siteAssessment
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setVentricularAssistDeviceSiteAssessmentSaga() error: ${e}`))
  }
}

export function* setVentricularAssistDeviceSiteAssessmentSaga() {
  yield takeLatest([VentricularAssistDeviceConstants.SET_SITE_ASSESSMENT], setVentricularAssistDeviceSiteAssessment)
}
